import api from "./api";

export const getProfileOptions = async () => api.get("/profile/options");

export const getProfiles = async () => api.get("/profile/list");

export const createProfile = async (payload) => api.post("/profile", payload);

export const updateProfile = async (id, payload) =>
  api.put(`/profile/${id}`, payload);

export const deleteProfile = async (id) => api.delete(`/profile/${id}`);

export const setDefaultProfile = async (id) => api.put(`/profile/${id}/default`);
